//import React from 'react';
/*
<script type="text/javascript">
	( function() {
		if (window.CHITIKA === undefined) { window.CHITIKA = { 'units' : [] }; };
		var unit = {"calltype":"async[2]","publisher":"gabecaterson","width":300,"height":600,"sid":"Chitika Default"};
		var placement_id = window.CHITIKA.units.length;
		window.CHITIKA.units.push(unit);
		document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
}());
</script>
<script type="text/javascript" src="//cdn.chitika.net/getads.js" async></script>
*/
import React, { Component } from 'react';


export class Ad extends React.Component {


	render () {

    return (
      <div className='ad'>

				<div class="CardBoxColumn">
					<div class="CardBox">
						<div class="CardBoxShadow"></div>
						<div class="CardBoxTitleOuter">
							<p class="CardBoxTitle font20">
							<br />Will you be an angel <br /> for an innocent minion? <br />

							</p>
							<p class="CardBoxTitle CardBoxSubtitle">
							</p>
						</div>
						<div class="CardBoxContainer">

							<div className="CardBoxBackground AdBoxBackground" />
							<div className="CardBoxTint" />

							<p class="CardBoxTitle CardBoxText">
								<br /> Every day, poor minion plush toys are suffering. They are crying out for help. Please, click the box on your screen and adopt a minion plush toy. Right now, there's a minion plush toy who needs your help. <br /> <br /> Buy one, and you can hold it... In the aaaaaaarms of an angel!
							</p>
							<p class="CardBoxTitle CardBoxText">

								<a target="_blank" rel="nofollow" href="https://www.amazon.com/gp/product/B07PN6TX6N/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07PN6TX6N&linkCode=as2&tag=deckscalibur-20&linkId=21794a934c05a043485024d5463decf2">
									<img border="0" src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07PN6TX6N&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=deckscalibur-20"
									class="adBorder"/>
								</a>
								<img class="affiliateAdImg" rel="nofollow" src="//ir-na.amazon-adsystem.com/e/ir?t=deckscalibur-20&l=am2&o=1&a=B07PN6TX6N" width="1" height="1" border="0" alt=""/>


							</p>
							<p class="CardBoxTitle CardBoxNote">
								This is an actual ad. As an Amazon Associate I earn from qualifying purchases. Minion plush toys do not actually suffer or cry out for help. Please hug responsibly.
							</p>
							</div>
						</div>
					</div>
      </div>
    );
  }
}

export default Ad;



// WEBPACK FOOTER //
// ./src/Components/Ad.js